<template>
  <div class="content flex-box vertical" v-if="activity">
    <div class="data-title">
      <div class="title-left flex-box">
        <span>共{{pagination.total}}条记录</span>
      </div>
      <a-form-model class="query-form" layout="inline">
        <a-form-model-item label="身份">
          <a-select
            placeholder="选择身份筛选"
            @change="getList"
            :options="guestTypeList"
            v-model="form.type"
            style="width: 200px">
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="分配状态">
          <a-select
            placeholder="选择分配状态筛选"
            @change="getList"
            :options="statusList"
            v-model="form.status"
            style="width: 200px">
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="">
          <a-input v-model="form.name" placeholder="输入姓名查询" style="width: 200px" @keyup.enter="getList"></a-input>
        </a-form-model-item>
      </a-form-model>
      <a-space class="title-btn">
        <a-button @click="getList">查询</a-button>
      </a-space>
    </div>
    <div class="data-area">
      <a-table
        ref="dataTable"
        row-key="id"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange">
        <template v-slot:action="text, record">
          <div class="row-btn">
            <entity-picker
              :value="record.giftStatus && record.giftStatus.gift ? [record.giftStatus.gift] : []"
              btn-text="选择礼品规格"
              url="/activity/activity-gift-spec"
              name-key="dining_type"
              :modal-width="1200"
              :query="`&filter[activity_id]=${activity.id}`"
              :columns="giftColumns"
              @change="handleMealChange($event, record)"
              style="display: inline-block">
              <a class="txt-btn">{{record.giftStatus ? '更换礼品' : '分配礼品'}}</a>
            </entity-picker>
            <a class="txt-btn" @click.stop="cancelMeal(record)" style="margin-left: 8px" v-if="record.giftStatus">取消礼品</a>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
    import entityPicker from "../../../components/form/entity-picker";
    import {giftColumns} from "../../../common/activity/gift";
    import {getGuestTypeText, guestTypeList} from "../../../common/activity/guest";
    import mixins from "../mixins";

    export default {
        name: "GiftAssign",
        components: {
            entityPicker
        },
        data() {
            return {
                loading: false,
                list: [],
                form: {},
                h: 500,
                giftColumns,
                pagination: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    showSizeChanger: true
                },
                guestTypeList: [{key: 0, title: '所有身份'}].concat(guestTypeList),
                statusList: [
                    {key: 0, title: '全部'},
                    {key: 1, title: '已分配'},
                    {key: 2, title: '未分配'}
                ],
                guest: null,
                gift: null,
                visible: false,
                moduleKey: 'gift-assign',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.$route.meta.action;
            },
            activity() {
                return this.$store.getters.activity;
            },
            columns() {
                const res = [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号', dataIndex: 'tel'},
                    {title: '身份标识', dataIndex: 'guestImg', customRender: (text, record) => text ? text.level: getGuestTypeText(record.type)},
                    {title: '礼品规格', dataIndex: 'gift', customRender: (text, record) => record.giftStatus && record.giftStatus.gift ? record.giftStatus.gift.name : '--'},
                    {title: '接待人员', dataIndex: 'receptionist', customRender: text => text && text.length > 0 ? text.map(r => r.name).join(" ") : '--'},
                    {title: '分配状态', dataIndex: 'giftStatus', customRender: text => text ? '已分配' : '未分配'},
                ];
                if(this.editable) {
                    res.push({title: '操作', key: 'action', fixed: 'right', width: 180, scopedSlots: { customRender: 'action'}});
                }
                return res;
            },
        },
        watch: {
            activity() {
                this.getList();
            }
        },
        created() {
            this.getList();
        },
        mounted() {
            this.setHeight();
            window.addEventListener("resize", this.setHeight, false);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.setHeight, false);
        },
        methods: {
            handleMealChange(gift, guest) {
                if(guest.giftStatus && guest.giftStatus.dining_id == gift.id) {
                    return;
                }
                let url = `/activity/activity-gift-allocation`, method = 'POST';
                const data = {
                    gift_id: gift.id
                }
                if(guest.giftStatus) {
                    url += `/${guest.giftStatus.id}`;
                    method = "PATCH";
                } else {
                    data.activity_id = guest.activity_id;
                    data.guest_id = guest.id;
                }
                this.$axios({
                    url,
                    method,
                    data
                }).then(res => {
                    res.gift = {...gift};
                    const giftStatus = guest.giftStatus ? {...guest.giftStatus, ...res} : res;
                    this.$set(guest, 'giftStatus', giftStatus);
                    this.$message.success("已分配");
                });
            },
            cancelMeal(item) {
                if(item.giftStatus) {
                    this.$confirm({
                        title: "提示",
                        content: `确定取消${item.name}的礼品分配吗？`,
                        onOk: () => {
                            let url = `/activity/activity-gift-allocation/${item.giftStatus.id}`;
                            this.$axios({
                                url,
                                method: "DELETE",
                            }).then(() => {
                                this.$message.success("已取消");
                                this.$set(item, 'giftStatus', null);
                            });
                        },
                        onCancel: () => {},
                    });
                }
            },
            handleTableChange(pagination) {
                let pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize = pagination.pageSize;
                this.pagination = pager;
                this.getList();
            },
            getList() {
                if(!this.activity || this.loading) return;
                this.loading = true;
                const id = this.activity.id;
                let {current, pageSize} = this.pagination;
                let url = `/activity/activity-guest?page=${current}&pageSize=${pageSize}&expand=giftStatus,guestImg,receptionist&filter[activity_id]=${this.activity.id}`;
                const form = this.form;
                if(form.type && form.type > 0) {
                    url += `&filter[type]=${form.type}`;
                }
                if(form.name) {
                    url += `&filter[name][like]=${form.name}`;
                }
                if(form.status > 0) {
                    url += `&filter[activity_gift_allocation.activity_id]=${id}&gift_status=1&is_allo=${form.status == 1 ? 1 : 0}`;
                }
                this.$axios(url, {noTempleFilter: true}).then(res => {
                    this.dealList(res.data);
                    this.$set(this.pagination, 'total', res.page.totalCount);
                }).finally(() => {
                    this.loading = false;
                });
            },
            dealList(list) {
                this.list = list;
            },
            setHeight() {
                let dataTale = this.$refs.dataTable;
                if(dataTale) {
                    let area = this.$el.querySelector(".data-area");
                    this.h = area.clientHeight - 54 - 64;
                }
            },
        }
    }
</script>

<style scoped>

</style>
